import { render } from "./Enrollment.vue?vue&type=template&id=ff56ef04"
import script from "./Enrollment.vue?vue&type=script&lang=js"
export * from "./Enrollment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Dashboard/Type/Enrollment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff56ef04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff56ef04', __exports__)) {
    api.reload('ff56ef04', __exports__)
  }
  
  module.hot.accept("./Enrollment.vue?vue&type=template&id=ff56ef04", () => {
    api.rerender('ff56ef04', render)
  })

}


export default __exports__